<ion-card class="order-card">
  <ion-card-header class="order-card-header" color="dark">
    <ion-card-title class="order-card-header__wrapper">
      <ion-label class="order-card-header__title">Round #{{tabOrdersStatus.number}}</ion-label>
    </ion-card-title>
  </ion-card-header>
  <ion-card-content class="order-card__content">
    <div *ngFor="let item of tabOrdersStatus.lineItems">
      <ion-item *ngIf="item.name !== (serviceChargeName || 'Kyoo Service Charge') && item.name !== 'Spot in line'" class="cart-item"
                [lines]="" [class.cart-item--transparent]="true">

        <ion-label class="cart-item__title">{{item.name}}
          <span *ngIf="item?.variationName && item?.variationName.length">({{item.variationName}})</span>
          <span class="cart-item__quantity">&nbsp;x {{item.quantity}}</span>
          <p *ngIf="item.modifiers?.length && !isAllModifiersHidden(item.modifiers)">
            <ion-text class="cart-item__subtitle">Modifiers:&nbsp;</ion-text>
            <ion-text class="cart-item__details">
              <ng-container *ngFor="let modifier of item.modifiers; let last = last" [hidden]="modifier.hiddenFromCustomer">
                <ion-text class="cart-item__details-name">{{modifier.name}}</ion-text>
                <ng-container *ngIf="!last">,&nbsp;</ng-container>
              </ng-container>
            </ion-text>
          </p>
        </ion-label>
        <div class="cart-item__right-info ion-float-right">
          <ion-label class="cart-item__price">
            ${{getFormattedPrice(item.base_price_money.amount, item.quantity)}}
          </ion-label>
        </div>
      </ion-item>
    </div>
  </ion-card-content>
</ion-card>
